import { render, staticRenderFns } from "./AgendaDay.vue?vue&type=template&id=2ef6153b&scoped=true"
import script from "./AgendaDay.vue?vue&type=script&lang=js"
export * from "./AgendaDay.vue?vue&type=script&lang=js"
import style0 from "./AgendaDay.vue?vue&type=style&index=0&id=2ef6153b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef6153b",
  null
  
)

export default component.exports